<template>
    <div
        class="modulecreate"
        :class="{ 'modulecreate--active': active, 'modulecreate--ontop': onTop }"
    >
        <div class="modulecreate__inner">
            <a
                class="modulecreate__button"
                v-tooltip="$helpers.uiText('U014')"
                href="#"
                v-on:click.prevent="$emit('click')"
                @mouseover="active = true"
                @mouseout="active = false"
            ></a>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            active: false
        };
    },
    components: {},
    methods: {},
    computed: {},
    created() {},
    watch: {},
    props: {
        onTop: null
    }
};
</script>
